var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractorBadges14({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 99,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h117.92v110H0z",
    style: {
      fill: "#00f",
      fillRule: "evenodd"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(.176 -5.984)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    fillRule: "evenodd",
    d: "M5 6a5 5 0 0 0-5 5v89a5 5 0 0 0 5 5h56a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5Zm17.256 5.372a1.535 1.535 0 0 0 0 3.07h20.72a1.535 1.535 0 0 0 0-3.07z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 58.674,
    r: 23.791,
    fill: "#e08585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd8d8",
    d: "M19.191 70.09c.07-.523.124-1.052.216-1.57.707-3.805 2.693-6.778 5.844-9.017C27.43 61.57 30 62.66 33 62.654c2.99 0 5.552-1.08 7.754-3.162.437.345.896.675 1.316 1.047 2.655 2.358 4.22 5.299 4.646 8.833.027.238.065.48.098.718v.863H19.186c.005-.286.005-.577.005-.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd8d8",
    d: "M33.652 43.326c.545.108 1.101.178 1.63.329 3.238.9 5.634 3.766 5.968 7.117a8.293 8.293 0 0 1-7.614 9.109c-4.203.35-8.072-2.644-8.785-6.805-.766-4.446 2.013-8.59 6.422-9.567.356-.08.723-.124 1.084-.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    fillRule: "evenodd",
    d: "M94 6a5 5 0 0 0-5 5v89a5 5 0 0 0 5 5h56a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5zm17.256 5.372a1.535 1.535 0 1 0 0 3.07h20.721a1.535 1.535 0 0 0 0-3.07z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.002,
    cy: 58.674,
    r: 23.791,
    fill: "#e08585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd8d8",
    d: "M108.193 70.09c.07-.523.124-1.052.216-1.57.707-3.805 2.693-6.778 5.844-9.017 2.18 2.067 4.749 3.157 7.749 3.151 2.989 0 5.552-1.08 7.754-3.162.437.345.895.675 1.316 1.047 2.655 2.358 4.22 5.299 4.646 8.833.027.238.065.48.097.718v.863h-27.627c.005-.286.005-.577.005-.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd8d8",
    d: "M122.654 43.326c.545.108 1.101.178 1.63.329 3.238.9 5.634 3.766 5.968 7.117a8.293 8.293 0 0 1-7.614 9.109c-4.203.35-8.072-2.644-8.785-6.805-.766-4.446 2.013-8.59 6.422-9.567.356-.08.723-.124 1.084-.183z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractorBadges14);
export default __webpack_public_path__ + "static/media/contractorBadges1.4.b799d0ecf4ab4f2aa75557bb0833ba7b.svg";
export { ForwardRef as ReactComponent };